/*
 *  InfoBanner.jsx
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React from "react";
import styled from "styled-components";
//==============================================================================
// Internal dep.
//==============================================================================
import { bannerSettings } from "../constants";

const InfoBackground = styled.div`
  position: sticky;
  z-index: 20;
  width: 100%;
  top: ${(props) => props.top};
  background: ${(props) => props.backgroundColor || "#e9e8ff"};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
`;
const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 24px;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  text-align: left;
  letter-spacing: 0px;
`;
const InfoIcon = styled.img`
  height: 28px;
  width: 28px;
  padding: 4px;
  background: #fff;
  box-shadow: 0px 0.875px 1.75px 0px #1e1f461f;
  border-radius: 100%;
  margin-right: 16px;
`;
const InfoMain = styled.div`
  font-weight: 500;
  line-height: 28px;
  color: ${(props) => props.color || "#474aff"};
  margin-right: 16px;
`;
const InfoSub = styled.div`
  font-weight: 400;
  line-height: 24px;
  color: ${(props) => props.subColor || "#47476b"};
`;

const InfoBanner = ({ status, marginTop = "-20px", marginBottom = "10px", top = "85px" }) => {
  const { backgroundColor, icon, mainText, extraText, color, subColor } =
    bannerSettings[status] || {};

  return (
    <InfoBackground
      backgroundColor={backgroundColor}
      marginTop={marginTop}
      marginBottom={marginBottom}
      top={top}
    >
      <InfoWrapper>
        {icon && <InfoIcon src={icon} alt="" />}
        {mainText && <InfoMain color={color}>{mainText}</InfoMain>}
        {extraText && <InfoSub subColor={subColor}>{extraText}</InfoSub>}
      </InfoWrapper>
    </InfoBackground>
  );
};

export default InfoBanner;
